import { createAsyncThunk } from '@reduxjs/toolkit'
import { st8LaunchGameService, st8WithdrawService } from 'network/services/st8.service'

export const st8LaunchGame = createAsyncThunk(
  'st8/launch-game',
  async (data, thunkApi) => {
    try {
      const res = await st8LaunchGameService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description || 'St8 launch failed')
    }
  }
)

export const st8Withdraw = createAsyncThunk(
  'st8/withdraw',
  async (data, thunkApi) => {
    try {
      const res = await st8WithdrawService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description || 'St8 withdraw failed')
    }
  }
)
